var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 3.1875C13.1783 3.1875 3.1875 13.1783 3.1875 25.5C3.1875 37.8217 13.1783 47.8125 25.5 47.8125C37.8217 47.8125 47.8125 37.8217 47.8125 25.5C47.8125 13.1783 37.8217 3.1875 25.5 3.1875ZM32.6769 25.8437L21.7995 33.7576C21.7399 33.8005 21.6696 33.8261 21.5964 33.8316C21.5231 33.8371 21.4498 33.8223 21.3844 33.7888C21.3191 33.7554 21.2642 33.7045 21.2258 33.6419C21.1875 33.5793 21.1671 33.5073 21.167 33.4339V17.6159C21.1668 17.5423 21.1869 17.4701 21.2252 17.4073C21.2635 17.3445 21.3184 17.2935 21.3839 17.2599C21.4494 17.2264 21.5229 17.2117 21.5963 17.2174C21.6696 17.2231 21.74 17.249 21.7995 17.2922L32.6769 25.2012C32.7282 25.2375 32.7702 25.2857 32.7991 25.3416C32.828 25.3974 32.8431 25.4595 32.8431 25.5224C32.8431 25.5854 32.828 25.6474 32.7991 25.7033C32.7702 25.7592 32.7282 25.8073 32.6769 25.8437V25.8437Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.97f42df67bf29a9310ba504d76770ca9.svg";
export { ForwardRef as ReactComponent };